import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const SpinnerContainer = styled(Box)(({ theme }) => ({
  inset: 0,
  width: '100%',
  minHeight: '100vh',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',

  '& .ZuiLoadingSpinner-root': {
    marginTop: theme.spacing(12)
  }
}));
